import axios from 'axios';
import { getBaseUrl } from '../core';

export function completeProductTour(params) {
    return axios.put(getBaseUrl('users/show_tour_done'), params);
}
